import "./Tooltip.css";
import React from "react";


export const Tooltip = ({ text, children }) => {
  return (
    <div className="tooltip">
      {children}
      <span className="tooltipText"> 
        {text}
      </span>
    </div>
  );
}
